import { useMemo } from 'react';

import { useAuth0 } from '@auth0/auth0-react';

import useAccounts from 'hooks/useAccounts';

/**
 * Hook to get the user's personal account ID
 * Falls back to the provided accountId if no personal account is found
 * @param {string} currentAccountId - Account ID to fall back to if no personal account is found
 * @return {string | undefined} The personal account ID, or undefined if no account is found
 */
export const usePersonalAccount = (
  currentAccountId: string,
): string | undefined => {
  const { user } = useAuth0();
  const { accounts } = useAccounts();

  return useMemo(() => {
    if (currentAccountId) {
      return currentAccountId;
    }

    const personalAccount = !!user?.email
      ? accounts.find(
          account =>
            account.name.includes(user.email ?? '') ||
            account.created_by === user.email,
        )
      : undefined;

    return personalAccount?.id || accounts[0]?.id;
  }, [accounts, user?.email, currentAccountId]);
};
